(function(module) {
    'use strict';

    function ViewSubAccountCtrl($http, $mdDialog, $stateParams, $state, SubAccount, App, AppTemplate, Display, Group, Playlist, Integration, Store, envService) {
        this.$onInit = () => {
            this.account = Store.getCurrentAccount();
            this.SLS_URI = envService.read('SLS_URI');

            this
                .get($stateParams.id)
                .then((subAccount) => {
                    this.subAccount = Store.setSingleModelData('subAccounts', subAccount.id, subAccount);
                })
                .catch((error) => {
                    console.log('Error loading sub account', error);
                });
        };

        this.get = (id) => {
            return SubAccount
                .findById({
                    id,
                })
                .$promise;
        };

        this.deleteFilesBySubAccountId = (subAccountId) => {
            return $http({
                url: `${this.SLS_URI}/files/delete-by-sub-account-id`,
                method: 'DELETE',
                data: {
                    subAccountId,
                    accountId: this.account.id,
                },
            });
        };

        this.deleteSubAccountAssets = (subAccountId) => {
            return Promise
                .all([
                    App.destroyAll({ where: { subAccountId } }).$promise,
                    AppTemplate.destroyAll({ where: { subAccountId } }).$promise,
                    Display.destroyAll({ where: { subAccountId } }).$promise,
                    Group.destroyAll({ where: { subAccountId } }).$promise,
                    Playlist.destroyAll({ where: { subAccountId } }).$promise,
                    Integration.destroyAll({ where: { subAccountId } }).$promise,
                    this.deleteFilesBySubAccountId(subAccountId),
                ]);
        };

        this.delete = () => {
            $mdDialog.show({
                locals: {
                    title: 'Are you sure you want to permanently remove this sub account?',
                    confirmationText: 'This will remove all APPS, DISPLAYS, GROUPS, PLAYLISTS, FILES & INTEGRATIONS under this sub account',
                    confirmText: 'Yes, I am sure',
                    cancelText: 'Cancel',
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        const subAccountId = Number($stateParams.id);
                        this.deleteSubAccountAssets(subAccountId)
                            .then(() => {
                                return SubAccount.removeById({ id: subAccountId }).$promise;
                            })
                            .then(() => {
                                return Store.removeSingleModelData('subAccounts', $stateParams.id);
                            })
                            .then(() => {
                                $state.go('root.my-account.sub-accounts');
                            })
                            .catch((error) => {
                                $scope.cancel();
                                console.error(error);
                                Raven.captureException(error);
                            });

                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.save = () => {
            SubAccount
                .prototype$patchAttributes(
                    { id: this.subAccount.id },
                    {
                        name: this.subAccount.name,
                    },
                )
                .$promise
                .then((response) => {
                    return Store.setSingleModelData('subAccounts', response.id, response);
                })
                .then(() => {
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };
    }

    module
        .config(($stateProvider) => {
            $stateProvider
                .state('root.my-account.sub-accounts.view', {
                    url: '/:id',
                    data: {
                        pageTitle: 'SUB_ACCOUNTS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<view-account-add-component />',
                        },
                    },
                });
        })
        .component('viewAccountAddComponent', {
            templateUrl: '/js/my-account/sub-accounts/view-sub-account/view-sub-account.html',
            controller: ViewSubAccountCtrl,
        });
})(angular.module('rocket.components'));
